import cashCountApi from "../../api/cash/cashCountApi";

const CashCountService = {

    /**
     * ▶️ Iniciar auditoría
     * POST /api/cash/counts/start
     */
    start: async () => {

        const response = await cashCountApi.addCustom("/start", {});

        return response.data;

    },

    /**
     * 🔎 Obtener arqueo activo
     * GET /api/cash/counts/active
     */
    getActive: async () => {

        const response = await cashCountApi.fetchCustom("/active");

        return response.data;

    },

    /**
     * ✅ Finalizar auditoría
     * POST /api/cash/counts/{id}/complete
     */
    complete: async (id: number, data: any) => {

        const response = await cashCountApi.addCustom(`/${id}/complete`, data);

        return response.data;

    }

};

export default CashCountService;